import { render } from "./search-bar.vue?vue&type=template&id=f1cb9478"
import script from "./search-bar.vue?vue&type=script&lang=js"
export * from "./search-bar.vue?vue&type=script&lang=js"

import "./search-bar.vue?vue&type=style&index=0&id=f1cb9478&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__